import React from 'react';

import {useEvent} from '../../../../../data/hooks/eventHooks';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import Info from './icons/Info';
import LeaveEvent from './icons/LeaveEvent';
import Map from './icons/Map';
import News from './icons/News';
import QRCode from './icons/QRCode';
import styles from './EventIcons.module.scss';

const EventIcons = props => {
    const {event, i18n} = props;

    return (
        <div className={[styles.EventIcons].join(' ')}>
            <Info event={event} i18n={i18n} />
            <News event={event} />
            <Map event={event} i18n={i18n} />
            <QRCode event={event} i18n={i18n} />
            <LeaveEvent event={event} i18n={i18n} />
        </div>
    );
};

export default EventIcons;
